import React from "react";
import { toggleDrawerAction } from "../../../store/action/admin/themeActions";
import { TranslatorNavigationTag } from "../../../languageTranslator/LanguageTranslatorTags";
import { Card, Col, Menu, Typography } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { css } from "@emotion/css";
const { Text } = Typography;
function BoxView({ subItem, current }) {
  const dispatch = useDispatch();
  const themeDefault = useSelector((state) => state.themeDefault);
  let trimmedCurrent = current?.replace(/\/[a-zA-Z0-9]{5}$/, "");

  let isTrue =
    current === subItem?.key ||
    subItem?.siblings.includes(current) ||
    subItem?.siblings.includes(trimmedCurrent);
  const cardStyle1 = css`
    transition: border 0.1s ease-in-out, color 0.1s ease-in-out;
    box-shadow: none;
    height: clamp(85px, 13.3vw, 185px);
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: ${themeDefault?.info?.borderRadius}px;
    border: solid 1px
      ${isTrue
        ? themeDefault?.info?.colorPrimary
        : themeDefault?.info?.newConfig?.headerDrawerItemBorder}!important;
    cursor: pointer;
    // color: ${themeDefault?.info?.newConfig?.headerDrawerTextColor};
    color: ${isTrue
      ? `${themeDefault?.info?.colorPrimary}`
      : `${themeDefault?.info?.newConfig?.headerDrawerTextColor}`} !important;
    .icon {
      color: ${isTrue
        ? `${themeDefault?.info?.colorPrimary}`
        : `${themeDefault?.info?.newConfig?.headerDrawerTextColor}`} !important;
    }
    background: ${themeDefault?.info?.newConfig?.cardBackground};
    backdrop-filter: blur(${themeDefault?.info?.newConfig?.cardBlur});
    gap: 12px;
    .icon {
      color: rgb(0 0 0 / 14%);
      transition: border 0.1s ease-in-out, color 0.1s ease-in-out;
    }
    .text {
      color: ${themeDefault?.info?.newConfig?.headerDrawerTextColor};
      transition: border 0.1s ease-in-out, color 0.1s ease-in-out;
    }
    :hover {
      border: solid 1px ${themeDefault?.info?.colorPrimary} !important;
      cursor: pointer;
      .icon {
        color: ${themeDefault?.info?.colorPrimary} !important;
      }
      color: ${themeDefault?.info?.colorPrimary}!important;
    }
  `;
  return (
    <Col span={6} key={subItem.key}>
      <Link
        style={{ height: "100%" }}
        to={subItem.link}
        onClick={() => dispatch(toggleDrawerAction(false))}
      >
        <div className={`${cardStyle1} theme-title-font`}>
          <div
            className={css`
              .anticon {
                font-size: clamp(24px, 2.6vw, 38px) !important;
              }
            `}
          >
            {subItem.icon}
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <p
              style={{
                fontWeight: "400",
                fontSize: "clamp(8px, 1vw, 13px)",
              }}
            >
              <TranslatorNavigationTag>{subItem.label}</TranslatorNavigationTag>
            </p>
          </div>
        </div>
      </Link>
    </Col>
  );
}

export default BoxView;
